import Modal from '@/Components/Modal';

const variantConfig = {
    danger: { icon: 'bi-exclamation-triangle', color: 'danger', btnClass: 'btn-danger' },
    warning: { icon: 'bi-exclamation-circle', color: 'warning', btnClass: 'btn-warning' },
    primary: { icon: 'bi-question-circle', color: 'primary', btnClass: 'btn-primary' },
};

export default function ConfirmModal({
    show,
    onHide,
    onConfirm,
    title = 'Confirm Action',
    message = 'Are you sure you want to proceed?',
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    variant = 'danger',
    processing = false,
}) {
    const config = variantConfig[variant] || variantConfig.danger;

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="sm"
            footer={
                <>
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={onHide}
                        disabled={processing}
                    >
                        {cancelText}
                    </button>
                    <button
                        type="button"
                        className={`btn ${config.btnClass}`}
                        onClick={onConfirm}
                        disabled={processing}
                    >
                        {processing ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" />
                                Processing...
                            </>
                        ) : (
                            confirmText
                        )}
                    </button>
                </>
            }
        >
            <div className="text-center py-2">
                <div className={`confirm-modal-icon bg-${config.color}-subtle text-${config.color}`}>
                    <i className={`bi ${config.icon}`}></i>
                </div>
                <h5 className="mt-3 mb-2">{title}</h5>
                <p className="text-muted mb-0">{message}</p>
            </div>
        </Modal>
    );
}
